<template>
  <div>
    <el-form size='mini' :inline='true'>
      <el-form-item>
        <span slot='label'><b>对比年：</b></span>
        <el-checkbox-group v-model="years">
          <el-checkbox-button v-for="i in 10" :label="(currentYear-i+1)+'年'" :key="i">
            {{ (currentYear - i + 1) + '年' }}
          </el-checkbox-button>
        </el-checkbox-group>
      </el-form-item>
    </el-form>
    <div style='height: 300px;width: 100%'>
      <div ref='chart' id='CommissionChart' style='height: 100%;width: 100%;' />
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import * as echarts from 'echarts'
import { numberFormatW } from '@/utils/utils'

const currentYear = moment().year()

let myChart = ''
export default {
  name: 'CommissionBarChart',
  props: {
    artistId: {
      type: String
    }
  },
  data() {
    return {
      currentYear,
      years: [currentYear + '年', (currentYear - 1) + '年']
    }
  },
  watch: {
    years: {
      deep: true,
      handler: function(val, oldVal) {
        if (val.length > 3) {
          this.$message.error('最多选择3个年份')
          this.years = oldVal
        } else {
          this.getData()
        }
      }
    }
  },
  mounted() {
    this.getData()
  },
  beforeDestroy() {
    if (myChart && !myChart.isDisposed) {
      myChart.dispose && myChart.dispose()
    }
  },
  methods: {
    getData: function() {
      if (this.years.length > 3) {
        return
      }
      myChart && myChart.showLoading()
      const requests = []
      for (const i in this.years) {
        const year = this.years[i].replace('年', '')
        const params = {
          artist_id: this.artistId,
          start_time: `${year}-01-01`,
          end_time: `${year}-12-31`
        }
        requests.push(this.$api.getRevenueItemStatistics(params))
      }
      const _this = this
      Promise.all(requests).then((results) => {
        _this.assemblyData(results)
      })
    },
    assemblyData: function(results) {
      const data = []
      results.forEach((tmp) => {
        const datum = {
          year: '',
          collection: []
        }

        const list = tmp.list || []
        list.forEach(item => {
          if (Array.isArray(item.items) && item.items.length > 0) {
            if (item.items[0] && item.items[0].time_month) {
              datum.year = item.items[0].time_month.split('/')[0]
              if (item.has === 'Y') {
                datum.collection = [...datum.collection, ...item.items]
              }
            }
          }
        })
        if (datum.year) {
          data.push(datum)
        }
      })
      this.drawChart(this.getSeries(data))
    },
    getSeries: function(data) {
      const series = {}
      const colors = [
        { main: '#ff80a4', other: '#ffd4e2' },
        { main: '#75a7ff', other: '#b6cfff' },
        { main: '#ffb980', other: '#ffe5d4' },
        { main: '#75ff80', other: '#b6ffd4' }
      ]
      data.forEach((item, i) => {
        const obj = {
          name: item.year + '年',
          data: [],
          type: 'bar',
          barWidth: '15%',
          seriesLayoutBy: 'row',
          itemStyle: {
            barBorderRadius: [30, 30, 0, 0],
            color: {
              x: 0,
              y: 0,
              x2: 1,
              y2: 1,
              colorStops: [
                { offset: 0, color: colors[i].main },
                { offset: 1, color: colors[i].other }
              ]
            }
          }
        }

        const total = {}
        item.collection.forEach(item => {
          const month = item.time_month.split('/') ? item.time_month.split('/')[1] : '0'
          const tmp_key = parseInt(month)
          if (total[tmp_key] === undefined) {
            total[tmp_key] = 0
          }
          total[tmp_key] += Number(item.income_3 || 0) + Number(item.income_4 || 0) + Number(item.income_5 || 0)
        })
        for (let i = 1; i <= 12; i++) {
          obj.data.push(total[i] || 0)
        }
        series[obj.name] = obj
      })
      return Object.values(series)
    },
    drawChart: function(series) {
      const dom = document.getElementById('CommissionChart')
      myChart = echarts.getInstanceByDom(dom) || echarts.init(dom, null, {
        renderer: 'canvas',
        useDirtyRect: false
      })
      const months = []
      for (let i = 1; i <= 12; i++) {
        months.push(i + '月')
      }
      const option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#666'
            }
          },
          formatter: function(params) {
            let result = params[0].axisValue + '<br/>'
            params.forEach(param => {
              let value = param.value
              // 金额格式化
              value = numberFormatW(Number(value), 2)
              result += param.marker + param.seriesName + ': ' + value + '<br/>'
            })
            return result
          }
        },
        legend: {
          icon: 'circle',
          height: 30,
          bottom: 0,
          itemWidth: 14,
          itemHeight: 20,
          itemGap: 13,
          textStyle: {
            color: '#666'
          },
          data: series.map(item => item.name)
        },
        xAxis: {
          type: 'category',
          data: months
        },
        yAxis: {
          type: 'value',
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          },
          axisLabel: {
            color: '#666',
            formatter(value) {
              return numberFormatW(value, 2)
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: '#666',
              type: 'dashed',
              opacity: 0.1
            }
          }
        },
        series
      }
      // 彻底覆盖旧配置，保证强制重渲染
      myChart.clear()
      myChart.setOption(option, true)
      myChart.hideLoading()
    }
  }
}
</script>
